module.exports = __webpack_public_path__ + "extrato_azul.svg?d928506c6864eb4b024a9fa085bd3555";


//////////////////
// WEBPACK FOOTER
// ./client/assets/icones_app/extrato_azul.svg
// module id = 1138
// module chunks = 0